export const validationRules = {
    clinicName: {
        required: true,
        maxLength: 70,
        noWhiteSpace: true
    },
    stateLicense: {
        required: true,
        maxLength: 25
    },
    issuingState: {
        required: true
    },
    expDate: {
        required: true,
        format: /^\d{2}\/\d{2}\/\d{4}$/,
        notInThePast: true,
        validDateFormat: true
    },
    dea: {
        required: true,
        format: /^^\S{2}\d{7}$/,
        maxLength: 25
    },
    deaExpDate: {
        required: true,
        format: /^\d{2}\/\d{2}\/\d{4}$/,
        notInThePast: true,
        validDateFormat: true
    },
    npi: {
        required: true,
        format: /^[0-9]{10}$/,
        maxLength: 10,
        minLength: 10
    },
};

export const validationRulesClinic = {
    addressLine1: {
        required: true,
        maxLength: 40,
        noWhiteSpace: true
    },
    city: {
        required: true,
        maxLength: 35,
        noWhiteSpace: true
    },
    state: {
        required: true
    },
    zipCode: {
        required: true,
        format: /^[0-9]{5}([0-9]{4})?$/
    },
    phone: {
        required: true,
        format: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/,
        isNotRepeated: true //Should has format of NOT repeated numbers
    },
    fax: {
        required: true,
        format: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/,
        isNotRepeated: true //Should has format of NOT repeated numbers
    }
};


// WEBPACK FOOTER //
// ./src/components/ClinicInformation/validationRules.ts